import * as React from 'react';

import { Text } from '../Text';
import { IAddress } from '../../types/geo';

export interface IAddressProps {
  address: IAddress[];
}

export function Address({ address }: IAddressProps) {
  return (
    <div>
      {address.map((addressItem, index) => {
        return (
          <span key={`key_${index}_${addressItem.fullUrl}`}>
            <Text textSize="small" color="black">
              {addressItem.title}
              {index !== address.length - 1 ? ', ' : ''}
            </Text>
          </span>
        );
      })}
    </div>
  );
}
